/**
 * Shared Tailwind classes for product card controls (home + shop).
 * Cards use `group` on the root so cart ping can show on hover only.
 */

/** Soft pulse behind orange cart FAB; visible when hovering the card (`group-hover`). */
export const PRODUCT_CARD_CART_PING =
  'pointer-events-none absolute inset-0 rounded-xl bg-orange-400/30 opacity-0 transition-opacity duration-300 group-hover:opacity-100 motion-safe:animate-ping motion-reduce:animate-none';

/** Wishlist heart — subtle lift like the chat FAB’s tactile feedback. */
export const PRODUCT_CARD_WISHLIST_MOTION =
  'shadow-sm transition-all duration-200 motion-safe:hover:scale-110 active:scale-95 hover:shadow-md';

/** “View product” outline CTA */
export const PRODUCT_CARD_VIEW_MOTION =
  'shadow-sm ring-1 ring-transparent transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md hover:shadow-orange-500/10 hover:ring-orange-200/70 active:translate-y-0 active:scale-[0.99]';

/** “Subscribe” outline CTA */
export const PRODUCT_CARD_SUBSCRIBE_MOTION =
  'shadow-sm ring-1 ring-transparent transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md hover:shadow-slate-400/10 hover:ring-slate-200/80 active:translate-y-0 active:scale-[0.99]';

/** Orange cart FAB chrome (chatbot-style depth; no duplicate scale — MagneticButton may add motion). */
export const PRODUCT_CARD_CART_CHROME =
  'shadow-lg shadow-orange-500/30 ring-1 ring-white/40 transition-all duration-300 hover:shadow-xl hover:shadow-orange-500/45';
